export default __webpack_public_path__ + "static/tub_b.efdfd0abdae4fdd2f033fc511d35354e.png";